import { Component, Input } from "@angular/core";
import { StepStateEnum, WorkflowStepConfig } from "./models/workflow-step-config";
import { EffectivenessPageType } from "../../../shared/enums";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { TranslocoPipe } from "@jsverse/transloco";
import { EffPopoverComponent } from "../eff-popover/eff-popover.component";
import { EffWorkflowPopoverComponent } from "./eff-workflow-popover/eff-workflow-popover.component";

@Component({
    selector: "eff-workflow-bar",
    templateUrl: "./eff-workflow-bar.component.html",
    styleUrls: ["./eff-workflow-bar.component.scss"],
    imports: [CommonModule, MatIconModule, TranslocoPipe, EffPopoverComponent, EffWorkflowPopoverComponent]
})
export class EffWorkflowBarComponent {
    @Input() steps: WorkflowStepConfig[] = [];

    effectivenessPageType = EffectivenessPageType;

    getStepStyle(step: WorkflowStepConfig) {
        switch (step.State) {
            case StepStateEnum.Active:
                return "active-step";
            case StepStateEnum.Completed:
                return "completed-step";
            case StepStateEnum.Disabled:
                return "disabled-step";
        }
    }
}
